import React, {Component} from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Homepage from './homepage/homepage';
import AboutUs from './homepage/aboutus';
import WhatIsRotary from './homepage/whatisrotary';
import CoreValue from './homepage/corevalue';
import Member from './homepage/member';
import PassPresidentsList from './homepage/pastPresidentsList';
import MemberList from './homepage/memberlist';
import ContactUs from './homepage/contactus';
import DashBoard from './homepage/dashboard';
import Events from './homepage/events';
import CentralTimes from './homepage/centraltimes';
import RegularElderlyVisit from './homepage/regular_elderly_visit';
import Kideract from './homepage/kideract';
import Rotaract from './homepage/rotaract';

import './App.css';
import Photos from './homepage/Photos';
import PhotoDetails from './homepage/PhotoDetails';
import MakeItSeries from "./homepage/our-services/make-it-series/MakeItSeries";
import InternationalServices from "./homepage/our-services/international-services/InternationalServices";
import DistrictMentorshipProgram from "./homepage/our-services/district-mentorship-program/DistrictMentorshipProgram";
import BreakingGuinessWR from "./homepage/our-services/breaking-guinness-wr/BreakingGuinnessWR";
import MakeASmile from "./homepage/our-services/make-a-smile/MakeASmile";
import Hkdsa from "./homepage/our-services/hkdsa/Hkdsa";

import AdoptASchool from "./homepage/our-services/adopt-a-school/AdoptASchool";
import PakTinEst from "./homepage/our-services/paktinest/PakTinEst";
import RIntelligence from "./homepage/our-services/r-intelligence/RIntelligence";
import Rcc from "./homepage/our-services/rcc/Rcc";

import SmartPeopleLiving from "./homepage/our-services/smart-people-living/SmartPeopleLiving";
import News from "./homepage/news/News";
import PrivacySecurity from "./homepage/privacy-security/PrivacySecurity";
import RegularMeeting from "./homepage/get-involved/RegularMeeting";
import ServiceProjects from "./homepage/get-involved/ServiceProjects";
import FellowshipEvent from "./homepage/get-involved/FellowshipEvent";
import BeOurMember from "./homepage/get-involved/BeOurMember";

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div>
          <Switch>

            <Route path="/dashboard" component={DashBoard} />
            <Route path="/contactus" component={ContactUs} />
            <Route path="/memberlist" component={MemberList} />
            <Route path="/boardmember" component={Member} />
            <Route path="/pastpresidentslist" component={PassPresidentsList} />
            <Route path="/corevalue" component={CoreValue} />
            <Route path="/whatisrotary" component={WhatIsRotary} />
            <Route path="/aboutus" component={AboutUs} />
            <Route path="/centraltimes" component={CentralTimes} />
            <Route path="/events" component={Events} />
            <Route path="/rev" component={RegularElderlyVisit} />
            <Route path="/kid" component={Kideract} />
            <Route path="/rotaract" component={Rotaract} />
            <Route path="/blogs/group/:group" component={Homepage} />
            <Route path="/photos/:photoId" component={PhotoDetails} />
            <Route path="/photos" component={Photos} />
            <Route path="/makeit" component={MakeItSeries}/>
            <Route path="/internationalservices" component={InternationalServices}/>
            <Route path="/districtmentorshipprogram" component={DistrictMentorshipProgram}/>
            <Route path="/guinnesswr" component={BreakingGuinessWR}/>
            <Route path="/makeasmile" component={MakeASmile}/>
            <Route path="/hkdsa" component={Hkdsa}/>
            <Route path="/smartpeopleliving" component={SmartPeopleLiving}/>
            <Route path="/news" component={News}/>
            <Route path="/privacysecurity" component={PrivacySecurity}/>
            <Route path="/regularmeeting" component={RegularMeeting}/>
            <Route path="/serviceprojects" component={ServiceProjects}/>
            <Route path="/fellowshipevents" component={FellowshipEvent}/>
            <Route path="/beourmember" component={BeOurMember}/>
            <Route path="/r-intelligence" component={RIntelligence} />
            <Route path="/adopt-a-school" component={AdoptASchool} />
            <Route path="/rcc" component={Rcc} />
            <Route path="/paktinest" component={PakTinEst} />
            <Route path="/" component={Homepage} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
